
const digest = '5970c9ceee5d4688f2dc9b832d62fd5db75c6a1e30136efae5637ad9f17068bb';
const classes = {"form":"_form_8cb96_1","title":"_title_8cb96_6","field":"_field_8cb96_10","emptyFormMessage":"_emptyFormMessage_8cb96_14"};
const css = `._form_8cb96_1 {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;
}

._title_8cb96_6 {
  margin-bottom: 8px;
}

._field_8cb96_10 {
  margin-bottom: 10px;
}

._emptyFormMessage_8cb96_14 {
  font-family: Rubik, sans-serif;
  color: #606061;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 16px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  